/* istanbul ignore file */
import React, { useRef } from 'react';
import { isKeyboardTriggeredEvent } from '@noths/polaris-client-utils';

import { ImperativeRef, PopoverButton } from 'src/components/molecules/PopoverButton';
import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup';
import { SelectedSortOption, SortOption, SortOptionValue } from 'src/types';
import * as copy from '../constants/copy';
import * as styles from '../styles/SortBy.styles';

export interface SortByProps {
  isLoading: boolean;
  sortingOptions: SortOption[];
  selectedSortOption: SelectedSortOption;
  onSelectSortOption: (value: SortOptionValue) => void;
}

export const SortBy = ({ sortingOptions, selectedSortOption, onSelectSortOption }: SortByProps) => {
  const popoverButtonRef = useRef<ImperativeRef | null>(null);
  const RadioButtons = (
    <RadioButtonGroup
      name={'sort-by-radio'}
      accessibleLabel={copy.SORT_BY}
      hideLabel
      value={selectedSortOption?.id}
      onChange={(value, event) => {
        if (!isKeyboardTriggeredEvent(event)) {
          popoverButtonRef.current?.closeContent();
        }
        onSelectSortOption(value);
      }}
      radioButtonData={sortingOptions.map((option) => ({
        labelText: option.title,
        value: option.id,
      }))}
    />
  );

  const popoverButtonMarkup = (
    <span css={styles.popoverButtonText}>
      {copy.SORT_BY}
      <span css={styles.popoverButtonOptionValue}>{selectedSortOption?.title}</span>
    </span>
  );

  return (
    <>
      <PopoverButton buttonMarkup={popoverButtonMarkup} ref={popoverButtonRef}>
        <div css={styles.popoverContent}>{RadioButtons}</div>
      </PopoverButton>
    </>
  );
};
